const ru = {
    common: {
        history: "историческая версия"
    }
};
export default ru;



// WEBPACK FOOTER //
// ./src/i18n/langs/ru.js